<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useShipStore } from '@/stores/ship'
import { useShipApiStore } from '@/stores/shipApi'

const shipStore = useShipStore()

const { items, selectedItems } = storeToRefs(shipStore)
const { getCapacityUnit: capacityUnit } = storeToRefs(useShipApiStore())

const isSelected = computed({
  get: () => {
    return items.value.every((item) => selectedItems.value.includes(item))
  },
  set: (value) => {
    shipStore.updateSelectedItems(value, items.value)
  }
})
</script>

<template>
  <tr>
    <th style="min-width: 24px" class="px-1"></th>
    <th class="px-1">
      <v-checkbox
        color="primary"
        v-model="isSelected"
        density="compact"
        hide-details
        @click.stop=""
        width="28"
        style="margin: auto"
      ></v-checkbox>
    </th>
    <th class="text-center px-0">Number</th>
    <th class="text-center">
      Capacity <small> [{{ capacityUnit }}]</small>
    </th>
    <th class="text-center"><small> Centre manifold </small>Eccentricity [m]</th>
    <th class="text-center">Length overall<small> [m]</small></th>
    <th class="text-center">Breadth<small> [m]</small></th>

    <th class="text-center" colspan="2">
      <v-row>
        <v-col class="pa-0"><small>Draught [m]</small></v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0 pr-1"> Laden</v-col>
        <v-col class="pa-0">Ballasted</v-col>
      </v-row>
    </th>

    <th class="text-center">Depth [m]</th>
    <th class="text-center" colspan="2">
      <v-row>
        <v-col class="pa-0"><small>Parallel body length [m]</small></v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0">Aftward</v-col>
        <v-col class="pa-0">Forward</v-col>
      </v-row>
    </th>

    <th class="text-center px-0">Actions</th>
  </tr>
</template>
